import { Component, OnInit } from '@angular/core';

import { DimensionService } from 'src/app/setup/_services/dimension.service';
import { Dimension } from 'src/app/_models/dimension';
import { Dimensions } from 'src/app/_models/dimensions';
import { DimensionsService } from 'src/app/_services/dimensions.service';


@Component({
  selector: 'app-dimensions',
  templateUrl: './dimensions.component.html',
  styleUrls: ['./dimensions.component.scss']
})
export class DimensionsComponent implements OnInit {

  dimType: string;
  id: number;

  dimensions: Dimensions;
  dimension: Dimension[];


  dimCostCentreLable = '';
  dimSupplierLable = '';
  dimClassLable = '';
  dimFacilityLable = '';
  dimRegionLable = '';
  dimDepartmentLable = '';
  dimFunctionLable = '';
  dimFundLable = '';
  dimProjectLable = '';
  dimItemLable = '';
  dimCostingLable = '';
  dim12Lable = '';
  dim13Lable = '';
  dim14Lable = '';
  dim15Lable = '';
  dim16Lable = '';
  dim17Lable = '';
  dim18Lable = '';
  dim19Lable = '';
  dim20Lable = '';

  dimCostCentreActive = false;
  dimSupplierActive = false;
  dimClassActive = false;
  dimFacilityActive = false;
  dimRegionActive = false;
  dimDepartmentActive = false;
  dimFunctionActive = false;
  dimFundActive = false;
  dimProjectActive = false;
  dimItemActive = false;
  dimCostingActive = false;
  dim12Active = false;
  dim13Active = false;
  dim14Active = false;
  dim15Active = false;
  dim16Active = false;
  dim17Active = false;
  dim18Active = false;
  dim19Active = false;
  dim20Active = false;
  
  constructor(private dimensionsService: DimensionsService, private dimensionService: DimensionService) {}


  ngOnInit() {
    this.dimensionsService.transactionReceived.subscribe((param) => {
      this.id = param[0];
      this.dimType = param[1];
      this.getDimensions()
        
    });
     
    this.dimensionService.getDimensionsFull().subscribe((_dimensions) => {
      this.dimension = _dimensions;
      this.setupDimensions();
    });
  }

 
  setupDimensions() {
    this.dimension.forEach((dimension) => {
      if (dimension.code === 'CC') {
        this.dimCostCentreActive = dimension.active;
        this.dimCostCentreLable = dimension.description;
      }
      if (dimension.code === 'DEP') {
        this.dimDepartmentActive = dimension.active;
        this.dimDepartmentLable = dimension.description;
      }
      if (dimension.code === 'SUP') {
        this.dimSupplierActive = dimension.active;
        this.dimSupplierLable = dimension.description;
      }
      if (dimension.code === 'FAC') {
        this.dimFacilityActive = dimension.active;
        this.dimFacilityLable = dimension.description;
      }
      if (dimension.code === 'REG') {
        this.dimRegionActive = dimension.active;
        this.dimRegionLable = dimension.description;
      }
      if (dimension.code === 'PROJ') {
        this.dimProjectActive = dimension.active;
        this.dimProjectLable = dimension.description;
      }
      if (dimension.code === 'FUNC') {
        this.dimFunctionActive = dimension.active;
        this.dimFunctionLable = dimension.description;
      }
      if (dimension.code === 'FUND') {
        this.dimFundActive = dimension.active;
        this.dimFundLable = dimension.description;
      }
      if (dimension.code === 'ITEM') {
        this.dimItemActive = dimension.active;
        this.dimItemLable = dimension.description;
      }
      if (dimension.code === 'COST') {
        this.dimCostingActive = dimension.active;
        this.dimCostingLable = dimension.description;
      }
      if (dimension.code === 'CLASS') {
        this.dimClassActive = dimension.active;
        this.dimClassLable = dimension.description;
      }
      if (dimension.code === 'DIM12') {
        this.dim12Active = dimension.active;
        this.dim12Lable = dimension.description;
      }
      if (dimension.code === 'DIM13') {
        this.dim13Active = dimension.active;
        this.dim13Lable = dimension.description;
      }
      if (dimension.code === 'DIM14') {
        this.dim14Active = dimension.active;
        this.dim14Lable = dimension.description;
      }
      if (dimension.code === 'DIM15') {
        this.dim15Active = dimension.active;
        this.dim15Lable = dimension.description;
      }
      if (dimension.code === 'DIM16') {
        this.dim16Active = dimension.active;
        this.dim16Lable = dimension.description;
      }
      if (dimension.code === 'DIM17') {
        this.dim17Active = dimension.active;
        this.dim17Lable = dimension.description;
      }
      if (dimension.code === 'DIM18') {
        this.dim18Active = dimension.active;
        this.dim18Lable = dimension.description;
      }
      if (dimension.code === 'DIM19') {
        this.dim19Active = dimension.active;
        this.dim19Lable = dimension.description;
      }
      if (dimension.code === 'DIM20') {
        this.dim20Active = dimension.active;
        this.dim20Lable = dimension.description;
      }
    });
  }
  getDimensions() {
    this.dimensionsService.getDimensions(this.id, this.dimType).subscribe((dim: Dimensions) => { 
      this.dimensions = dim;
    });
  }
}
